export const useEnterpriseOptions = (
  enterprise: string,
  queryParams: {
    [key: string]: string | undefined;
  },
  cloudinaryPath: string,
) => {
  const isBaseEnterprise = enterprise.toUpperCase() === "INKIND" || !enterprise;
  const colorMode = queryParams.colorMode ?? "dark";
  const purchaseModeTiers =
    queryParams.purchaseMode === "tiers" && isBaseEnterprise;
  const showDeliveryOnly = queryParams.tag === "delivery";
  const isPassPage = queryParams.pass === "true";
  const ctaDisplay = !isBaseEnterprise ? "none" : queryParams.ctaDisplay;
  const inKindDomain = "https://app." + enterprise + ".com";
  const ikname =
    enterprise === "inkind" ? enterprise.replace("k", "K") : enterprise;
  const newCloudinaryPath =
    queryParams.env !== "prod"
      ? cloudinaryPath
      : "https://res-5.cloudinary.com/equityeats/image/upload/";
  return {
    colorMode,
    showDeliveryOnly,
    isBaseEnterprise,
    purchaseModeTiers,
    isPassPage,
    ctaDisplay,
    ikname,
    inKindDomain,
    newCloudinaryPath,
  };
};
